import React, { memo } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SparklesIcon, RocketIcon, ZapIcon, BrainIcon, TrophyIcon } from 'lucide-react';
export function SuperhumanPage() {
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-fuchsia-950 to-purple-950 flex flex-col" data-id="element-211">
      <Header data-id="element-212" />
      <section className="max-w-6xl mx-auto px-6 py-20 relative" data-id="element-213">
        <div className="absolute inset-0 bg-gradient-to-br from-fuchsia-500/10 via-purple-500/10 to-fuchsia-500/10 rounded-3xl blur-3xl" data-id="element-214"></div>
        <div className="text-center mb-16 relative" data-id="element-215">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-fuchsia-500 to-purple-500 px-6 py-2.5 rounded-full border border-fuchsia-400/50 mb-8 shadow-lg shadow-fuchsia-500/30" data-id="element-216">
            <ZapIcon className="w-4 h-4 text-white" data-id="element-217" />
            <span className="text-sm font-bold text-white" data-id="element-218">Coming Soon</span>
            <ZapIcon className="w-4 h-4 text-white" data-id="element-219" />
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-220">
            Welcome to{' '}
            <span className="bg-gradient-to-r from-fuchsia-400 via-purple-400 to-fuchsia-400 bg-clip-text text-transparent" data-id="element-221">
              SUPERHUMAN
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-fuchsia-100 max-w-4xl mx-auto leading-relaxed font-medium" data-id="element-222">
            An exclusive program for high-performers ready to transcend human
            limitations and achieve elite-level optimization
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-16 relative" data-id="element-223">
          <div className="bg-slate-800/80 backdrop-blur-sm p-8 rounded-2xl border border-fuchsia-500/30 hover:shadow-2xl hover:shadow-fuchsia-500/20 hover:border-fuchsia-500/40 transition-all duration-300" data-id="element-224">
            <div className="bg-gradient-to-br from-fuchsia-500 to-purple-600 p-4 rounded-xl w-fit mb-6" data-id="element-225">
              <BrainIcon className="w-8 h-8 text-white" data-id="element-226" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-227">
              Cognitive Mastery
            </h3>
            <p className="text-fuchsia-200 leading-relaxed" data-id="element-228">
              Unlock superhuman focus, memory, and mental clarity
            </p>
          </div>
          <div className="bg-slate-800/80 backdrop-blur-sm p-8 rounded-2xl border border-fuchsia-500/30 hover:shadow-2xl hover:shadow-fuchsia-500/20 hover:border-fuchsia-500/40 transition-all duration-300" data-id="element-229">
            <div className="bg-gradient-to-br from-fuchsia-500 to-purple-600 p-4 rounded-xl w-fit mb-6" data-id="element-230">
              <TrophyIcon className="w-8 h-8 text-white" data-id="element-231" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-232">
              Peak Performance
            </h3>
            <p className="text-fuchsia-200 leading-relaxed" data-id="element-233">
              Achieve elite physical capabilities and recovery
            </p>
          </div>
          <div className="bg-slate-800/80 backdrop-blur-sm p-8 rounded-2xl border border-fuchsia-500/30 hover:shadow-2xl hover:shadow-fuchsia-500/20 hover:border-fuchsia-500/40 transition-all duration-300" data-id="element-234">
            <div className="bg-gradient-to-br from-fuchsia-500 to-purple-600 p-4 rounded-xl w-fit mb-6" data-id="element-235">
              <RocketIcon className="w-8 h-8 text-white" data-id="element-236" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-237">
              Longevity Optimization
            </h3>
            <p className="text-fuchsia-200 leading-relaxed" data-id="element-238">
              Reverse biological aging and extend healthspan
            </p>
          </div>
        </div>
        <div className="bg-slate-800/80 backdrop-blur-sm p-8 md:p-12 rounded-2xl shadow-2xl border border-fuchsia-500/30 relative overflow-hidden" data-id="element-239">
          <div className="absolute inset-0 bg-gradient-to-br from-fuchsia-500/5 to-purple-500/5 rounded-2xl" data-id="element-240"></div>
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-fuchsia-500/10 to-transparent rounded-full blur-3xl" data-id="element-241"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-purple-500/10 to-transparent rounded-full blur-3xl" data-id="element-242"></div>
          <div className="relative" data-id="element-243">
            <div className="text-center mb-10" data-id="element-244">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-fuchsia-500 to-purple-500 px-6 py-2.5 rounded-full border border-fuchsia-400/50 mb-8 shadow-lg shadow-fuchsia-500/30" data-id="element-245">
                <SparklesIcon className="w-4 h-4 text-white" data-id="element-246" />
                <span className="text-sm font-bold text-white" data-id="element-247">
                  Exclusive Waitlist
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-248">
                Be Among the First
              </h2>
              <p className="text-lg text-fuchsia-200 max-w-2xl mx-auto font-medium" data-id="element-249">
                Join the waitlist to get early access when SUPERHUMAN launches.
                Limited spots available.
              </p>
            </div>
            <iframe src="https://link.peptidescienceinstitute.com/widget/survey/rciRJDLJyMYvGJZNfF0b" style={{
            border: 'none',
            width: '100%',
            height: '600px'
          }} id="rciRJDLJyMYvGJZNfF0b" title="survey" data-id="element-250"></iframe>
          </div>
        </div>
      </section>
      <Footer data-id="element-251" />
    </div>;
}